import _ from 'lodash';
import React from 'react';
import moment from 'moment';

import {DATE_FORMAT_API} from 'utils/datetime';

import CursorPaginator from 'components/CursorPaginator';
import {CursorPaginationForStore} from 'utils/pagination';

import {
  StickyBookingsForMonth,
  ScrollableBookingsForMonth,
  StickyTableHeaders,
  ScrollableTableHeaders
} from './components';

import './styles.css';

interface BookingsTableProps {
  bookings: any;
  redirectToBookingDetail: any;
  openBookingNotesModal: any;
  onPageChange: (
    {cursor, pageSize}: {cursor: number; pageSize: number}
  ) => void;
  pagination: CursorPaginationForStore;
}

class BookingsTable extends React.Component<BookingsTableProps> {
  state = {
    openedBookings: [] // openedBookings holds the ids of the opened bookings
  };

  onNextPage = ({pageSize}) => {
    const cursorBookingId = _.get(_.last(this.props.bookings), 'id');

    this.props.onPageChange({
      pageSize,
      cursor: cursorBookingId
    });
  };

  onPrevPage = ({pageSize}) => {
    const cursorBookingId = _.get(_.first(this.props.bookings), 'id');

    this.props.onPageChange({
      pageSize,
      cursor: cursorBookingId
    });
  };

  toggleBookingRow = ({bookingId}) =>
    this.setState({
      openedBookings: _.xor(this.state.openedBookings, [bookingId])
    });

  render() {
    const {
      bookings,
      redirectToBookingDetail,
      openBookingNotesModal
    } = this.props;

    const groupedBookingsByMonth: any = _.groupBy(bookings, booking =>
      moment(booking.periodStartDate, DATE_FORMAT_API).format('MMMM YYYY')
    );

    return (
      <div className="BookingsTable">
        <div className="BookingsTable__content colab-row-space-between">
          <div className="BookingsTable--sticky">
            <StickyTableHeaders />
            {_.map(
              groupedBookingsByMonth,
              (bookingsForMonth, labelForMonth) => (
                <StickyBookingsForMonth
                  key={labelForMonth}
                  month={labelForMonth}
                  bookings={bookingsForMonth}
                  redirectToBookingDetail={redirectToBookingDetail}
                  toggleBookingRow={this.toggleBookingRow}
                  openedBookings={this.state.openedBookings}
                />
              )
            )}
          </div>
          <div className="BookingsTable--scrollable">
            <ScrollableTableHeaders />
            {_.map(
              groupedBookingsByMonth,
              (bookingsForMonth, labelForMonth) => (
                <ScrollableBookingsForMonth
                  key={labelForMonth}
                  bookings={bookingsForMonth}
                  openBookingNotesModal={openBookingNotesModal}
                  openedBookings={this.state.openedBookings}
                />
              )
            )}
          </div>
        </div>
        <CursorPaginator
          pagination={this.props.pagination}
          onNextPage={this.onNextPage}
          onPrevPage={this.onPrevPage}
          onPageChange={this.props.onPageChange}
        />
      </div>
    );
  }
}

export default BookingsTable;
